module.exports = __webpack_public_path__ + "static/media/Morocco.4423663d.png";